import { render, staticRenderFns } from "./AdminProjectList.vue?vue&type=template&id=66e3174a"
import script from "./AdminProjectList.vue?vue&type=script&lang=js"
export * from "./AdminProjectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports